import { render, staticRenderFns } from "./merge.vue?vue&type=template&id=a16bd892&scoped=true"
import script from "./merge.vue?vue&type=script&lang=js"
export * from "./merge.vue?vue&type=script&lang=js"
import style0 from "./merge.vue?vue&type=style&index=0&id=a16bd892&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16bd892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a16bd892')) {
      api.createRecord('a16bd892', component.options)
    } else {
      api.reload('a16bd892', component.options)
    }
    module.hot.accept("./merge.vue?vue&type=template&id=a16bd892&scoped=true", function () {
      api.rerender('a16bd892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/merge.vue"
export default component.exports